import request from '@/utils/request'
import requestblob from '@/utils/requestblob'
import config from '@/config'
// import requestDownload from '@/utils/requestDownload'

export default {
  getAreaRainfall (params) { // 分区雨量列表
    return request.get(config.ApiYJ + '/RainWater/GetAnalyticalRain', { params })
  },
  // 导出
  exportAreaRainfall (params) { // 分区雨量导出
    return requestblob.get(config.ApiYJ + '/RainWater/GetAnalyticalRainExport', { params })
  },
  getDynamicResevoirStorage (params) { // 水库动态蓄水列表
    return request.get(config.ApiYJ + '/RainWater/GetReservoirDynamicWater', { params })
  },
  // 导出
  exportDynamicResevoirStorage (params) { // 水库动态蓄水导出
    return requestblob.get(config.ApiYJ + '/RainWater/GetReservoirDynamicWaterExport', { params })
  },
  // 到站率统计
  stationArriveRate () {
    return request.get(config.ApiYJ + '/RainWater/station_arrive_rate')
  },
  // 水雨情简报
  rainWaterBriefing () {
    return request.get(config.ApiYJ + '/RainWater/rain_water_briefing')
  },
  // 水雨情日报
  rainWaterDaily (params) {
    return request.get(config.ApiYJ + '/RainWater/rain_water_daily', { params })
  },
  // 水情快报
  waterNews (params) {
    return request.get(config.ApiYJ + '/RainWater/water_news', { params })
  },
  // 雨水情告知单获取模板
  rainWaterNoticeTemplate (params) {
    return request.get(config.ApiYJ + '/intelligentdocument/get_rain_water_notice', { params })
  },
  // 雨水情告知单列表
  getListRainWaterNotice (params) {
    return request.get(config.ApiYJ + '/intelligentdocument/list_rain_water_notice', { params })
  },
  // 保存雨水情告知单
  saveRainWaterNotice (params) {
    return request.post(config.ApiYJ + '/intelligentdocument/save_rain_water_notice', params)
  },
  // 删除雨水情告知单
  delRainWaterNotice (id) {
    return request.post(config.ApiYJ + '/intelligentdocument/del_rain_water_notice', { id: id })
  },
  // 雨水情告单已经预警时间列表
  getListWarnRecordTime (params) {
    return request.get(config.ApiYJ + '/intelligentdocument/list_warn_record_time')
  },
  // 异常数据报表
  getAbnormalValue (params) {
    return request.get(config.ApiYJ + '/RainWater/GetAbnormalValue', { params })
  },
  saveAbnormalValue (params) {
    return request.post(config.ApiYJ + '/RainWater/SaveAbnormalValue', params)
  },
  getAbnormalData (params) {
    return request.get(config.ApiYJ + '/RainWater/GetAbnormalData', { params })
  },
  // 导出缺报数据
  exportProblemStation (params) {
    return request.post(config.ApiYJ + '/Export/problemStationExport', params)
  }
}
